import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const AddEntityButton = ({
  children,
  iconOnly = true,
  buttonProps = {},
}) => {
  const { style, ...restButtonProps } = buttonProps;

  return (
    <Button
      type="primary"
      htmlType="button"
      {...restButtonProps}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {iconOnly ? <PlusOutlined /> : <>{children}</>}
    </Button>
  );
};

export default AddEntityButton;
